//import CodeOne from "./components/chart";
import React, { useEffect } from 'react';

import LandingPage from "./components/landing";
import { AuthProvider } from "./components/firebase/AuthContext";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
//import ZoomPanTest from "./components/loggedOut"
import PrivateRoute from "./PrivateRoute"
import Workspace from "./components/Workspace";
import Test from "./components/test";
import Blog from "./components/blog";

import {ReactFlowProvider} from 'reactflow';

import AOS from 'aos';
import 'aos/dist/aos.css';
import Gateway from './components/gateway';
import BlogOne from './components/blogs/blogOne';
import BlogTwo from './components/blogs/blogTwo';
import BlogThree from './components/blogs/blogThree';
import BlogFour from './components/blogs/blogFour';
import BlogFive from './components/blogs/blogFive';
import BlogSix from './components/blogs/blogSix';
import BlogSeven from './components/blogs/blogSeven';
import blogEight from './components/blogs/blogEight';
import blogNine from './components/blogs/blogNine';
import blogTen from './components/blogs/blogTen';
import blogEleven from './components/blogs/blogEleven';
import blogTwelve from './components/blogs/blogTwelve';
import blogThirteen from './components/blogs/blogThirteen';
import blogFourteen from './components/blogs/blogFourteen';
import blogFifteen from './components/blogs/blogFifteen';
import blogSixteen from './components/blogs/blogSixteen';
import blogSeventeen from './components/blogs/blogSeventeen';
import blogEighten from './components/blogs/blogEighten';
import blogNineteen from './components/blogs/blogNineteen';
import blogTwenty from './components/blogs/blogTwenty';

import Contact from './components/loose/contact';
import Terms from './components/loose/terms';
import Privacy from './components/loose/Privacy';
import BlogTwentyOne from './components/blogs/blogTwentyOne';
import BlogTwentyTwo from './components/blogs/blogTwentyTwo';
import BlogTwentyThree from './components/blogs/blogTwentyThree';
import BlogTwentyFour from './components/blogs/blogTwentyFour';
import BlogTwentyFive from './components/blogs/blogTwentyFive';
import BlogTwentySix from './components/blogs/blogTwentySix';
import BlogTwentySeven from './components/blogs/blogTwentySeven';


function App() {

  useEffect(() => {
    
    AOS.init();
    
  }, []);

  return (

  <div >
    <Router >
    <ReactFlowProvider>
    <AuthProvider>
      <Switch>
        <Route exact path="/" component={LandingPage} />
        <Route exact path="/blog" component={Blog} />
        <Route exact path="/What-does-dyslexia-do-to-a-person" component={BlogOne} />
        <Route exact path="/How-does-dyslexia-affect-thinking" component={BlogTwo} />
        <Route exact path="/Benefits-of-dyslexia" component={BlogThree} />
        <Route exact path="/How-does-dyslexia-affect-communication" component={BlogFour} />
        <Route exact path="/What-is-a-thinking-framework" component={BlogFive} />
        <Route exact path="/Does-dyslexia-affect-verbal-comprehension" component={BlogSix} />
        <Route exact path="/Understanding-communication-challenges-for-neurodivergent-individuals" component={BlogSeven} />
        <Route exact path="/Navigating-relationships-as-a-neurodivergent-individual" component={blogEight} />
        <Route exact path="/Exploring-the-Connection-between-Dyslexia-and-Difficulty-with-Explanation" component={blogNine} />
        <Route exact path="/How-to-Develop-an-Effective-Communication-Strategy-in-Your-Personal-Life" component={blogTen} />
        <Route exact path="/Why-Framework-Thinking-is-Crucial-for-Success-in-Today’s-World" component={blogEleven} />
        <Route exact path="/Understanding-Mental-Frameworks-What-They-Are-and-Why-They-Matter" component={blogTwelve} />
        <Route exact path="/Why-do-people-say-dyslexia-is-a-gift" component={blogThirteen} />
        <Route exact path="/Understanding-the-Rarity-of-Dyslexia-in-the-UK" component={blogFourteen} />
        <Route exact path="/5-Essential-Steps-for-Effective-Idea-Generation" component={blogFifteen} />
        <Route exact path="/Effective-Communication-How-to-Discuss-Your-Ideas-with-People" component={blogSixteen} />
        <Route exact path="/Mastering-the-Art-of-Communicating-Complex-Ideas" component={blogSeventeen} />
        <Route exact path="/Clear-Communication-Tips-and-Strategies-for-Effective-Communication" component={blogEighten} />
        <Route exact path="/The-Importance-of-Communication-in-Interviews" component={blogNineteen} />
        <Route exact path="/Mastering-Classroom-Management-Understanding-the-Cs-of-Communication" component={blogTwenty} />
        <Route exact path="/The-Importance-of-Effective-Communication" component={BlogTwentyOne} />
        <Route exact path="/The-Top-Reasons-Why-Communication-Breakdowns-Occur" component={BlogTwentyTwo} />
        <Route exact path="/The-Ultimate-Guide-to-Effective-Communication-While-Working-Remotely" component={BlogTwentyThree} />
        <Route exact path="/Navigating-Communication-Breakdown-Strategies-for-Recovery-and-Resolution" component={BlogTwentyFour} />
        <Route exact path="/Is-Dyslexia-A-Condition-Developed-Or-Born-With" component={BlogTwentyFive} />
        <Route exact path="/Common-Misconceptions-About-Dyslexia" component={BlogTwentySix} />
        <Route exact path="/Mind-Mapping-A-Powerful-Tool-for-Effective-Communication" component={BlogTwentySeven} />

        <Route exact path="/privacy" component={Privacy} />
        <Route exact path="/terms" component={Terms} />
        <Route exact path="/contact" component={Contact} />


        <PrivateRoute exact path="/workspace" component={Workspace} />
        <PrivateRoute exact path="/payment" component={Gateway} />
        <Route exact path="/:anyOther" component={LandingPage} />
      </Switch>
      </AuthProvider>
      </ReactFlowProvider>
    </Router>
  </div>

  );
}

export default App;


//        <PrivateRoute exact path="/test" component={Test} />
